var overrideValues = {};

var set = function set(name, value) {
  overrideValues[name] = value;
};

var get = function get(name) {
  return overrideValues[name];
};

export default {
  set: set,
  get: get
};